import React, { createContext, useState } from 'react';

export type FeedbackMode = 'annotate' | 'sketch' | 'none';

export interface FeedbackModeContextValue {
    feedbackMode: FeedbackMode;
    setFeedbackMode: (feedbackMode: FeedbackMode) => void;
}

const FeedbackModeContext = createContext<FeedbackModeContextValue>({
    feedbackMode: 'annotate',
    setFeedbackMode: () => null,
});

interface FeedbackModeProviderProps {
    initialFeedbackMode?: FeedbackMode;
    children: React.ReactNode;
}

function FeedbackModeProvider({
    children,
    initialFeedbackMode = 'annotate',
}: FeedbackModeProviderProps) {
    const [feedbackMode, setFeedbackMode] = useState(initialFeedbackMode);

    return (
        <FeedbackModeContext.Provider
            value={{
                feedbackMode,
                setFeedbackMode,
            }}
        >
            {children}
        </FeedbackModeContext.Provider>
    );
}

export function useFeedbackModeContext() {
    const context = React.useContext(FeedbackModeContext);
    if (context === undefined) {
        throw new Error('useFeedbackModeContext must be used within a FeedbackModeProvider');
    }
    return context;
}

export default FeedbackModeProvider;
